import React from 'react';

export const AliceIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_954_720)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 7.99967C0 12.4178 3.58158 15.9993 7.99967 15.9993C12.4178 15.9993 15.9993 12.4178 15.9993 7.99967C15.9993 3.58158 12.4178 0 7.99967 0C3.58158 0 0 3.58158 0 7.99967ZM7.99982 11.5027C6.44078 11.4967 4.91104 11.1535 4.33675 10.5821C2.90993 9.16226 6.37826 3.72275 8.00161 3.71484C9.62138 3.72275 13.0897 9.16226 11.6629 10.5821C11.0886 11.1535 9.55882 11.4967 7.99982 11.5027Z"
                fill="currentColor"
                fillOpacity="1"
            />
        </g>
        <defs>
            <clipPath id="clip0_954_720">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
